/**
 * Shared loading UI — full page (e.g. article fetch) or inline block (e.g. home updates strip).
 */
export default function PageLoading({
  message = 'Loading…',
  variant = 'page',
  pageId,
  className = '',
}) {
  const inner = (
    <>
      <span className="page-loading-spinner" aria-hidden />
      <span className="page-loading-text">{message}</span>
    </>
  );

  if (variant === 'inline') {
    return (
      <div
        className={`loading-inline${className ? ` ${className}` : ''}`}
        role="status"
        aria-live="polite"
      >
        {inner}
      </div>
    );
  }

  return (
    <div
      id={pageId}
      className={`page-loading--full${className ? ` ${className}` : ''}`}
      role="status"
      aria-live="polite"
    >
      <div className="page-loading-inner">{inner}</div>
    </div>
  );
}
